import React, { useEffect, useState } from 'react';
import { LoginRegisterFormProps, MultiStepRegistrationFormProps } from 'Interfaces/LoginRegisterFormProps';
import LoginForm from 'SharedComponents/LoginForm';
import SignupForm from 'SharedComponents/SignupForm';

const LoginRegisterForm: React.FunctionComponent<
    LoginRegisterFormProps & Partial<MultiStepRegistrationFormProps>
> = formProps => {
    const { defaultEmail } = formProps;
    const [isLoading, setIsLoading] = useState(false);
    const [inputEmail, setInputEmail] = useState(defaultEmail);
    const [hideSwitch, setHideSwitch] = useState(false);

    const props = {
        isMagicLinkEnabled: false,
        mailcheckOptions: {},
        focusSignupFormEmail: false,
        emailPlaceholderAnimStartDelay: 0,
        ...formProps,
    };

    const { setIsFormReady } = props;

    useEffect(() => {
        if (typeof setIsFormReady === 'function') {
            setIsFormReady(true);
        }
    }, [setIsFormReady]);

    useEffect(() => {
        if (props.defaultEmail !== '') {
            setHideSwitch(true);
            setInputEmail(props.defaultEmail);
        }
    }, [props.defaultEmail, setHideSwitch, setInputEmail]);

    const emailAlwaysValid = () => true;

    return (
        <>
            {props.showLogin && (
                <LoginForm
                    formName={props.formIdentifiers?.form.login}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    backendEmailValidator={emailAlwaysValid}
                    defaultEmail={props.defaultEmail}
                    forgetPasswordRedirectUrl={props.forgetPasswordRedirectUrl}
                    apiBaseUrl={props.apiBaseUrl}
                    handleShowLoginToggle={props.handleShowLoginToggle}
                    hideSwitch={hideSwitch}
                    redirectUrl={props.redirectUrl}
                    inputEmail={inputEmail}
                    handleEmailChange={(email: string) => setInputEmail(email)}
                    // TODO Avoid props drilling.
                    handleClose={props.handleClose}
                />
            )}
            {!props.showLogin && (
                <SignupForm
                    formName={props.formIdentifiers?.form.signup}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    isFolded={props.isSignupFormFolded}
                    setIsFolded={props.setIsSignupFormFolded}
                    backendEmailValidator={emailAlwaysValid}
                    privacyPolicy={props.privacyPolicy ?? ''}
                    isMultiStep={props.isMultiStep}
                    isLastStep={props.isLastStep ?? false}
                    setIsLastStep={props.setIsLastStep ?? (() => ({}))}
                    activeStep={props.activeStep ?? 1}
                    setActiveStep={props.setActiveStep ?? (() => ({}))}
                    focusSignupFormEmail={props.focusSignupFormEmail}
                    animatedSubmitButtonCta={props.animatedSubmitButtonCta}
                    animateEmailPlaceholder={props.animateEmailPlaceholder}
                    isReferral={props.isReferral}
                    isFormReady={props.isFormReady}
                    mailcheckOptions={props.mailcheckOptions}
                    apiBaseUrl={props.apiBaseUrl}
                    handleShowLoginToggle={props.handleShowLoginToggle}
                    hideSwitch={hideSwitch}
                    redirectUrl={props.redirectUrl}
                    inputEmail={inputEmail}
                    handleEmailChange={(email: string) => setInputEmail(email)}
                    // TODO Avoid props drilling
                    handleClose={props.handleClose}
                />
            )}
        </>
    );
};

export default LoginRegisterForm;
